 
import DATA from './DATA'
import { store } from './../store'
import { openDB, deleteDB, wrap, unwrap } from 'idb';  
let NAME = "INDEX-DB"  
let DB_PROMISE;
const REQUEST_TIMER = 1;


const initializeDB = async(name)=>{ 
    try {  
        if (!('indexedDB' in window)) { 
            store.dispatch("ERROR",{
                error:'This browser doesn\'t support IndexedDB',
                from:'initializeDB',
                page:NAME, 
            })
            return null;
        } 
        DB_PROMISE = await openDB(DATA.APP.SERVER2,DATA.APP.SERVER_VERSION,{
            upgrade(db,oldVersion,newVersion,transaction){
                createStore(db)
                if (oldVersion == 0) {
                } else { 
                } 
            }
        }) 
        return DB_PROMISE
    } catch (error) {
        store.dispatch("ERROR",{
            error:{
                error:error,
                name:name,
            },
            from:'initializeDB',
            page:NAME, 
        })
    }
} 
const createStore = (db)=>{ 
    try {
        if (!db.objectStoreNames.contains(DATA.ITEMS.ERRORS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.ERRORS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  }
        if (!db.objectStoreNames.contains(DATA.ITEMS.PERMISSIONS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.PERMISSIONS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  }
        if (!db.objectStoreNames.contains(DATA.ITEMS.USER_DETAILS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.USER_DETAILS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  }
        if (!db.objectStoreNames.contains(DATA.ITEMS.USER_LIVES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.USER_LIVES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  }
        if (!db.objectStoreNames.contains(DATA.ITEMS.USER_GROUPS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.USER_GROUPS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  }
        if (!db.objectStoreNames.contains(DATA.ITEMS.MESSAGES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.MESSAGES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  }
        if (!db.objectStoreNames.contains(DATA.ITEMS.ID_TYPES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.ID_TYPES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        if (!db.objectStoreNames.contains(DATA.ITEMS.OCCURRENCES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.OCCURRENCES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        if (!db.objectStoreNames.contains(DATA.ITEMS.REPORTERS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.REPORTERS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        if (!db.objectStoreNames.contains(DATA.ITEMS.REPORTER_CATEGORIES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.REPORTER_CATEGORIES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 

        //location
        if (!db.objectStoreNames.contains(DATA.ITEMS.COUNTRIES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.COUNTRIES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  }
        if (!db.objectStoreNames.contains(DATA.ITEMS.REGIONS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.REGIONS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  }
        if (!db.objectStoreNames.contains(DATA.ITEMS.DISTRICTS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.DISTRICTS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        if (!db.objectStoreNames.contains(DATA.ITEMS.CONSTITUENCIES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.CONSTITUENCIES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        if (!db.objectStoreNames.contains(DATA.ITEMS.CONSTITUENCIES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.CONSTITUENCIES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        if (!db.objectStoreNames.contains(DATA.ITEMS.WARDS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.WARDS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        if (!db.objectStoreNames.contains(DATA.ITEMS.CENTRES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.CENTRES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        if (!db.objectStoreNames.contains(DATA.ITEMS.TRADITION_AUTHORITIES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.TRADITION_AUTHORITIES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        
        //questions
        if (!db.objectStoreNames.contains(DATA.ITEMS.QUESTION_TYPES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.QUESTION_TYPES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        if (!db.objectStoreNames.contains(DATA.ITEMS.QUESTION_CATEGORIES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.QUESTION_CATEGORIES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        if (!db.objectStoreNames.contains(DATA.ITEMS.QUESTION_TIMELINES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.QUESTION_TIMELINES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        if (!db.objectStoreNames.contains(DATA.ITEMS.QUESTION_TIMELINES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.QUESTION_TIMELINES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        if (!db.objectStoreNames.contains(DATA.ITEMS.QUESTION_STAGES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.QUESTION_STAGES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        
        
        //DATA
        if (!db.objectStoreNames.contains(DATA.ITEMS.QUESTIONNAIRES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.QUESTIONNAIRES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        if (!db.objectStoreNames.contains(DATA.ITEMS.REPORTS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.REPORTS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  }  
        if (!db.objectStoreNames.contains(DATA.ITEMS.WEB_REPORTS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.WEB_REPORTS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 
        if (!db.objectStoreNames.contains(DATA.ITEMS.WHATSAPP_REPORTS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.WHATSAPP_REPORTS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  }  
        if (!db.objectStoreNames.contains(DATA.ITEMS.SMS_REPORTS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.SMS_REPORTS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  }  
        if (!db.objectStoreNames.contains(DATA.ITEMS.PERSONAL_REPORTS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.PERSONAL_REPORTS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  }  
        if (!db.objectStoreNames.contains(DATA.ITEMS.ANSWER_PERSONAL_REPORTS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.ANSWER_PERSONAL_REPORTS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  }  
        if (!db.objectStoreNames.contains(DATA.ITEMS.MOBILE_REPORTS.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.MOBILE_REPORTS.values.toUpperCase(),{keyPath:"key"}) 
        }else{  }  
        if (!db.objectStoreNames.contains(DATA.ITEMS.TRACKING_UPDATES.values.toUpperCase())) {
            db.createObjectStore(DATA.ITEMS.TRACKING_UPDATES.values.toUpperCase(),{keyPath:"key"}) 
        }else{  } 


        
    
        
    } catch (error) {
        store.dispatch("ERROR",{
            error: error ,
            from:'createStore',
            page:NAME, 
        })
    } 
} 
const addData =  (name,data,clear)=>{
    return new Promise((resolve,reject)=>{
        setTimeout(async() => {
            let response = {
                from:'addData',
                page:NAME, 
                name:name, 
                data:data, 
                clear:clear, 
            }
            try {   
                let db = await initializeDB(name) 
                if (!db.objectStoreNames.contains(name.toUpperCase())) { 
                    reject({
                        ...response,
                        error:'store not define'
                    }) 
                } 
                let transaction = db.transaction(name.toUpperCase(),'readwrite')
                let db_store = await transaction.objectStore(name.toUpperCase())
                if (clear) {
                    db_store.clear()
                }
                let value = null
                if (Array.isArray(data)) {
                    value = await Promise.all(data.map(item=>{
                        return  db_store.put(item) 
                    }))
                } else {
                    value = await db_store.put(data) 
                }
                await transaction.done  
                
                resolve({
                    response:'success',
                    success:true,
                    data:value,
                    clear:clear,
                    name:name
                }) 
                
            }catch (error) {
                store.dispatch("ERROR",{
                    ...response,
                    error:{
                        error: error,
                        data:data,
                        name:name,
                    },  
                })
                reject({
                    ...response,
                    error:error
                })
            } 
        }, REQUEST_TIMER);
    })
}
const deleteStore = (name)=>{
    return new Promise((resolve,reject)=>{
        let response={
            from:'deleteStore',
            page:NAME, 
            name:name, 
        }
        setTimeout(async() => {
            try {  
                    let db = await initializeDB(name) 
                    if (!db.objectStoreNames.contains(name.toUpperCase())) { 
                        reject({
                            ...response,
                            error:'store not define'
                        }) 
                    } 
                    let transaction = db.transaction(name.toUpperCase(),'readwrite')
                    let db_store = await transaction.objectStore(name.toUpperCase())
                    db_store.clear()
                    await transaction.done  
                    resolve({
                        response:'success', 
                        success:true,
                        name:name
                    }) 
                
            } catch (error) {
                store.dispatch("ERROR",{
                    ...response,
                    error:{
                        error: error, 
                        name:name,
                    },  
                })
                reject({
                    ...response,
                    error:error,
                })
            }
        }, REQUEST_TIMER); 
    })
}
const deleteStoreId =  (name,key)=>{
    return new Promise((resolve,reject)=>{
        let response={
            from:'deleteStoreId',
            page:NAME, 
            name:name, 
            key:key, 
        }
        setTimeout(async() => {
            try {  
                let db = await initializeDB(name,key) 
                if (!db.objectStoreNames.contains(name.toUpperCase())) { 
                    reject({
                        ...response,
                        error:'store not define',
                        name:name,
                        key:key
                    }) 
                } 
                let transaction = db.transaction(name.toUpperCase(),'readwrite')
                let db_store = await transaction.objectStore(name.toUpperCase())
                db_store.delete(key)
                await transaction.done  
                resolve({
                    response:'success', 
                    success:true,
                    name:name,
                    key:key
                })  
            } catch (error) {
                store.dispatch("ERROR",{
                    ...response,
                    error:{
                        error: error, 
                        name:name,
                        key:key
                    }, 
                    
                })
                reject({
                    ...response,
                    error:error
                })
            }
        }, REQUEST_TIMER);
    })
}
const getData = (name,key,update_store,company_key)=>{
    return new Promise((resolve,reject)=>{
        let response={
            from:'getData',
            page:NAME, 
            name:name, 
            key:key, 
            update_store:update_store, 
            company_key:company_key, 
        }
        setTimeout(async() => {
            try {  
                let db = await initializeDB(name) 
                if (!db.objectStoreNames.contains(name.toUpperCase())) { 
                    reject({
                        ...response,
                        error:'store not define'
                    }) 
                } 
                let transaction = db.transaction(name.toUpperCase(),'readwrite')
                let db_store = await transaction.objectStore(name.toUpperCase()) 
                let data = []
                if (company_key) {
                    data = await db_store.get(company_key)
                }else if (key) {
                    data = await db_store.get(key)
                } else {
                    data = await db_store.getAll()  
                }
                await transaction.done  
                if (data && company_key) {
                    data = data?data.data:null
                }
                if (update_store ) { 
                    await updateStore(name,data)
                }
                resolve({
                    data:data,
                    success:true,
                    response:'success',
                    isArray:key?false:true,
                    update_store:update_store
                })  
            } catch (error) {
                store.dispatch("ERROR",{
                    ...response,
                    error:error,
                    
                })
                reject({
                    ...response,
                    error:error
                })
            }
        }, REQUEST_TIMER);
    })
} 
const updateStore = (name,data)=>{
    return new Promise(async(resolve,reject)=>{
        let response={
            from:'updateStore',
            page:NAME, 
            name:name,
            data:data,
        }
        try { 
            if (!name) { 
                reject({
                    ...response,
                    error:"payload required"
                }) 
            } 
            let user_state = store.state?store.state.users:null
            let item_state = store.state?store.state.items:null
            if (!user_state || !item_state) { 
                reject({
                    ...response,
                    error:{
                        error:'no sate',
                        data:data,
                        name:name,
                        store:store
                    }, 
                }) 
            }
             
            if (name.toUpperCase()===DATA.ITEMS.ERRORS.values.toUpperCase()) { 
                item_state.ERRORS = data
            }else if (name.toUpperCase()===DATA.ITEMS.USERS.values.toUpperCase()) {
                user_state.USERS = data
            }else if (name.toUpperCase()===DATA.ITEMS.USER_DETAILS.values.toUpperCase()) {
                user_state.USER_DETAILS = data    
            }else if (name.toUpperCase()===DATA.ITEMS.USER_LIVES.values.toUpperCase()) {
                user_state.USER_LIVES = data    
            }else if (name.toUpperCase()===DATA.ITEMS.USER_GROUPS.values.toUpperCase()) {
                user_state.USER_GROUPS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.PERMISSIONS.values.toUpperCase()) {
                user_state.PERMISSIONS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.VISITERS.values.toUpperCase()) {
                user_state.VISITERS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.MESSAGES.values.toUpperCase()) {
                item_state.MESSAGES = data     
            }else if (name.toUpperCase()===DATA.ITEMS.REGIONS.values.toUpperCase()) {
                item_state.REGIONS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.DISTRICTS.values.toUpperCase()) {
                item_state.DISTRICTS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.ID_TYPES.values.toUpperCase()) {
                item_state.ID_TYPES = data     
            } else if (name.toUpperCase()===DATA.ITEMS.OCCURRENCES.values.toUpperCase()) {
                item_state.OCCURRENCES = data     
            } else if (name.toUpperCase()===DATA.ITEMS.REPORTERS.values.toUpperCase()) {
                item_state.REPORTERS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.REPORTER_CATEGORIES.values.toUpperCase()) {
                item_state.REPORTER_CATEGORIES = data     
            }
            
            //LOCATIONS
            else if (name.toUpperCase()===DATA.ITEMS.COUNTRIES.values.toUpperCase()) {
                item_state.COUNTRIES = data     
            }else if (name.toUpperCase()===DATA.ITEMS.REGIONS.values.toUpperCase()) {
                item_state.REGIONS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.DISTRICTS.values.toUpperCase()) {
                item_state.DISTRICTS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.CONSTITUENCIES.values.toUpperCase()) {
                item_state.CONSTITUENCIES = data     
            }else if (name.toUpperCase()===DATA.ITEMS.WARDS.values.toUpperCase()) {
                item_state.WARDS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.CENTRES.values.toUpperCase()) {
                item_state.CENTRES = data     
            }else if (name.toUpperCase()===DATA.ITEMS.TRADITION_AUTHORITIES.values.toUpperCase()) {
                item_state.TRADITION_AUTHORITIES = data     
            }  
            
            //DATA
            else if (name.toUpperCase()===DATA.ITEMS.QUESTIONNAIRES.values.toUpperCase()) {
                item_state.QUESTIONNAIRES = data     
            }else if (name.toUpperCase()===DATA.ITEMS.REPORTERS.values.toUpperCase()) {
                item_state.REPORTERS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.MOBILE_REPORTS.values.toUpperCase()) {
                item_state.MOBILE_REPORTS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.SMS_REPORTS.values.toUpperCase()) {
                item_state.SMS_REPORTS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.PERSONAL_REPORTS.values.toUpperCase()) {
                item_state.PERSONAL_REPORTS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.ANSWER_PERSONAL_REPORTS.values.toUpperCase()) {
                item_state.ANSWER_PERSONAL_REPORTS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.WEB_REPORTS.values.toUpperCase()) {
                item_state.WEB_REPORTS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.WHATSAPP_REPORTS.values.toUpperCase()) {
                item_state.WHATSAPP_REPORTS = data     
            }else if (name.toUpperCase()===DATA.ITEMS.TRACKING_UPDATES.values.toUpperCase()) {
                item_state.TRACKING_UPDATES = data     
            } 
            
            
            else{
                reject({
                    ...response,
                    error:'name not found', 
                })
            }  
            resolve({
                response:'success',
                data:data,
                name:name
            })
        } catch (error) {
            store.dispatch("ERROR",{
                ...response,
                error:error, 
            })
        }
    })
} 

const addItems = (payload)=>{
    return new Promise((resolve,reject)=>{
        let response={
            from:'addItems',
            page:NAME, 
            payload:payload
        } 
        setTimeout(async() => {
            try {  
                let name = payload?payload.name:null
                let data = payload?payload.data:null
                let clear = payload?payload.clear:null
                let company_key = payload?payload.company_key:null
                let update_from_db = payload?payload.update_from_db:null
                if (!name || !data) {  
                    reject({
                        ...response,
                        error:"payload required",
                    })
                }   
                if (company_key) {
                    data = {
                        key:company_key,
                        data:data
                    }
                }
                let res = await addData(name,data,clear) 
                if (!update_from_db) {
                    store.dispatch("update_from_db",payload)  
                } 
                resolve({
                    ...res,
                    success:true,
                })  
            } catch (error) {
                reject({
                    ...response,
                    error:error
                }) 
            }
        }, REQUEST_TIMER);
    })
} 
const getItems = (payload)=>{
    return new Promise((resolve,reject)=>{
        let response={
            from:'getItems',
            payload:payload,
            page:NAME, 
        } 
        setTimeout(async() => { 
            try {  
                let name = payload?payload.name:null
                let key = payload?payload.key:null
                let update_store = payload?payload.update_store:null
                let company_key = payload?payload.company_key:null
                let update_from_db = payload?payload.update_from_db:null
                if (!name) { 
                    reject({
                        ...response,
                        error:"payload required"
                    })
                }   
                let res = await getData(name,key,update_store,company_key)   
                if (!update_from_db) {
                    store.dispatch("update_from_db",payload)  
                } 
                resolve({
                    ...res,
                    success:true,
                })
            } catch (error) { 
                reject({
                    ...response,
                    error:error
                }) 
            }   
        }, REQUEST_TIMER);
    })
}  
const getUserDetails = ()=>{
    return new Promise(async(resolve,reject)=>{ 
        try {  
            let current = await getItems({
                name:DATA.ITEMS.USER_LIVES.values,
                key:DATA.APP.USER_TIMELINE.current
            }) 
            let action_request = await getItems({
                name:DATA.ITEMS.USER_LIVES.values,
                key:DATA.APP.USER_TIMELINE.action_request
            }) 
            let logged = await getItems({
                name:DATA.ITEMS.USER_LIVES.values,
                key:DATA.APP.USER_TIMELINE.logged_out
            })
            
            let current_uid = current?current.data?current.data.uid:null:null
            let action_request_uid = action_request?action_request.data?action_request.data.uid:null:null
            let logged_uid = logged?logged.data?logged.data.uid:null:null
            let user_details_data = null
    
            if (action_request_uid) {
                user_details_data = await getItems({
                    name:DATA.ITEMS.USER_DETAILS.values,
                    key:action_request_uid
                })
            }else if (current_uid) {
                user_details_data = await getItems({
                    name:DATA.ITEMS.USER_DETAILS.values,
                    key:current_uid
                })
            } 
            let  user_details = user_details_data?user_details_data.data:null 
             
            resolve({
                response:'success',
                current_uid:current_uid,
                action_request_uid:action_request_uid,
                logged_uid:logged_uid,
                user_details:user_details,
            })  
        } catch (error) {
            store.dispatch("ERROR",{
                error:error,
                from:'getUserDetails',
                page:NAME, 
            })
            reject({
                error:error,
                from:'getUserDetails',
                page:NAME, 
                response:'not success'
            })   
        }
    })
} 
const deleteItems = (payload)=>{
    return new Promise((resolve,reject)=>{
        let response={
            from:'deleteItems',
            payload:payload,
            page:NAME, 
        } 
        setTimeout(async() => {
            try { 
                let name = payload?payload.name:null
                let key = payload?payload.key:null
                if (!name) { 
                    reject({
                        ...response,
                        error:"payload required"
                    })
                } 
                let res = key?await deleteStoreId(name,key) : await deleteStore(name) 
                resolve({
                    ...res,
                    success:true
                })
            } catch (error) { 
                reject({
                    ...response,
                    error:error
                })
            }
        }, 10);
    })
} 
export default  { 
    addItems:addItems, 
    getItems:getItems, 
    getUserDetails:getUserDetails,
    deleteItems:deleteItems, 
};